<template>
  <div>
    <transition name="slide">
      <div class="ship-info-list">
        <TopNavbar title="物流详情"></TopNavbar>
        <div class="ship-container">
          <div class="loading-container" v-if="isLoading">
            <Loading></Loading>
          </div>
          <div v-else>
            <Steps direction="vertical"
                   active-color="#fc9153"
                   :active="0" v-if="shipInfoList && shipInfoList.length > 0">
              <Step v-for="item in shipInfoList" :key="item.time">
                <div>{{item.status}}</div>
                <div>{{item.time}}</div>
              </Step>
            </Steps>
            <div v-else class="empty-status">
              <div>暂无</div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import {Toast, Steps, Step, Loading} from "vant"
  import TopNavbar from "../common/TopNavbar";

  export default {
    name: "ShipInfo",
    components: {
      TopNavbar,
      Loading, Step, Steps,
    },
    data() {
      return {
        shipInfoList: [],
        isLoading: false,
        shipId: "",
        shipBy: "",
        phoneNum: "",
      };
    },
    mounted() {
      this.shipId = this.$route.query.ship_id
      this.shipBy = this.$route.query.ship_by
      this.phoneNum = this.$route.query.phone_number
      if (this.shipId && this.shipBy) {
        this.shipInfoStatus()
      }
    },
    methods: {
      goBack() {
        this.$router.go(-1)
      },

      shipInfoStatus() {
        this.isLoading = true
        let params = {
          ship_id: this.shipId,
          ship_by: this.shipBy,
          phone_number: this.phoneNum,
        }
        this.$store.dispatch("GetShipStatus", params).then((data) => {
          if (data.code === 0) {
            this.shipInfoList = data.data.status_list
          }
          this.isLoading = false
        }, () => {
          this.isLoading = false
          Toast("网络错误")
        })
      },
    },
    computed: {}
  };
</script>
<style lang="scss" scoped>

  .ship-info-list {
    position: relative;
    padding: 48px 0;
  }

  .loading-container {
    display: flex;
    align-items: center;
    justify-content: center;
    background: white;
  }

  .ship-container {
    background: white;
  }

  .empty-status {
    text-align: center;
    padding-top: 15px;
    background: white;
    color: grey;
  }

</style>
